export const findNodeId = (state, qdId) => {
    // console.log('qd_id: ', qdId)
        if (state.quantitiesById[`q${qdId}`]) {
            return `q${qdId}`;
        }

        if (state.quantitiesById[`uq${qdId}`]) {
            return `uq${qdId}`;
        }

        return null;
}